import { FlexBox, IconButton, Table, Timestamp } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Template, TemplateTypes } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';
import { PureComponent } from 'react';


import styles from '../../templates.module.scss';

import { TemplateLanguagesCell } from './templateLanguagesCell/templateLanguagesCell';

type TemplatesTableRowOwnProps = {
  template: Template;
  templatesOpenRemoveModal: (template: Template) => void;
  templatesOpenAddModal: (template: Template) => void;
  hasLanguageTranslationControlFF: boolean;
  templateType: TemplateTypes;
};

type StateProps = {};

type Props = TemplatesTableRowOwnProps & StateProps;

export class TemplatesTableRow extends PureComponent<Props> {
  @boundMethod
  openEditModal() {
    const { templatesOpenAddModal, template, templateType } = this.props;

    ampli.settingsTemplatesEditTemplateButtonClicked({
      templateType,
      templateName: template.name,
    });
    templatesOpenAddModal(template);
  }

  @boundMethod
  openRemoveModal() {
    const { templatesOpenRemoveModal, template, templateType } = this.props;

    ampli.settingsTemplatesRemoveTemplateButtonClicked({
      templateType,
      templateName: template.name,
    });
    templatesOpenRemoveModal(template);
  }

  render() {
    const { template, hasLanguageTranslationControlFF } = this.props;

    return (
      <Table.Tr>
        <Table.Td>{template.name}</Table.Td>
        <Table.Td>
          <Timestamp relative time={template.created_at} />
        </Table.Td>
        <Table.Td>
          {template.last_edited_at ? (
            <Timestamp relative time={template.last_edited_at} />
          ) : (
            '-'
          )}
        </Table.Td>
        {hasLanguageTranslationControlFF && (
          <Table.Td>
            <TemplateLanguagesCell translations={template.translations} />
          </Table.Td>
        )}
        <Table.Td>
          <FlexBox alignItems="center">
            <IconButton
              variant="tertiary"
              icon="pen"
              className={styles.editButton}
              onClick={this.openEditModal}
            />
            <IconButton
              variant="tertiary"
              icon="trash"
              onClick={this.openRemoveModal}
            />
          </FlexBox>
        </Table.Td>
      </Table.Tr>
    );
  }
}
